import { UrlBundles, UserInfo } from "Libs/core";
import axios from "axios";
import * as a from "../types/actions.types";

const resetPassword = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    [a.SEND_RECOVERY_MAIL]({ commit }, payload) {
      return axios.post(UrlBundles.accountApi + "/ForgotPassword", {
        email: payload.email,
      });
    },
  },
};

export default resetPassword;
